import { StoreBodyBlock } from 'constants/enums';
import {
  ETemplateStudioSidebarBlock,
  TemplateStudioBlock
} from 'state/template-studio.state.service';

import { BundleDesignsSecondarySidebar } from '../Sidebar/Secondary/Blocks/Bundles';
import { DailyBonusBadgesSecondarySidebar } from '../Sidebar/Secondary/Blocks/DailyBonusBadges';
import { PopupDesignsSecondarySidebar } from '../Sidebar/Secondary/Blocks/Popups';
import { ProgressBarsSecondarySidebar } from '../Sidebar/Secondary/Blocks/ProgressBars';
import { PromotionDesignsSecondarySidebar } from '../Sidebar/Secondary/Blocks/Promotions';
import {
  RewardCalendarBadgeSecondarySidebar,
  RewardCalendarDesignsSecondarySidebar
} from '../Sidebar/Secondary/Blocks/RewardCalendar';
import { RollingOffersDesignsSecondarySidebar } from '../Sidebar/Secondary/Blocks/RollingOffers';
import {
  TriggeredPopupsBadgeSecondarySidebar,
  TriggeredPopupsDesignsSecondarySidebar
} from '../Sidebar/Secondary/Blocks/TriggeredPopups';

export const OPACITY_OPTIONS = [
  { value: 0, label: '0%' },
  { value: 25, label: '25%' },
  { value: 50, label: '50%' },
  { value: 75, label: '75%' },
  { value: 100, label: '100%' }
];

export const createColorSetValueHandler = (
  fieldName: string,
  getCurrentValue: () => any,
  setValue: (name: string, value: any) => void,
  onChange: (value: any) => void
) => {
  return (inputFieldName: string, newValue: unknown) => {
    const currentValue = getCurrentValue();
    let updatedValue = currentValue;

    if (inputFieldName === fieldName) {
      updatedValue = { colorOne: newValue as string };
    } else if (inputFieldName.includes('.colorOne')) {
      updatedValue = { ...currentValue, colorOne: newValue as string };
    } else if (inputFieldName.includes('.colorTwo')) {
      updatedValue = { ...currentValue, colorTwo: newValue as string };
    } else if (inputFieldName.includes('.gradientDirection')) {
      updatedValue = { ...currentValue, gradientDirection: newValue as any };
    } else {
      updatedValue = { colorOne: currentValue };
    }

    setValue(fieldName, updatedValue);
    onChange(updatedValue);
  };
};

export const mapBlockToSecondarySidebar: Partial<
  Record<TemplateStudioBlock, React.FC>
> = {
  [StoreBodyBlock.bundles]: BundleDesignsSecondarySidebar,
  [StoreBodyBlock.specialOffers]: PromotionDesignsSecondarySidebar,
  [StoreBodyBlock.rollingOffers]: RollingOffersDesignsSecondarySidebar,
  [StoreBodyBlock.progressBars]: ProgressBarsSecondarySidebar,
  [StoreBodyBlock.dailyBonusBadge]: DailyBonusBadgesSecondarySidebar,
  [StoreBodyBlock.triggeredPopups]: TriggeredPopupsBadgeSecondarySidebar,
  [StoreBodyBlock.rewardCalendar]: RewardCalendarBadgeSecondarySidebar,
  [ETemplateStudioSidebarBlock.POPUP]: PopupDesignsSecondarySidebar,
  [ETemplateStudioSidebarBlock.TRIGGERED_POPUPS_POPUP]:
    TriggeredPopupsDesignsSecondarySidebar,
  [ETemplateStudioSidebarBlock.REWARD_CALENDAR_POPUP]:
    RewardCalendarDesignsSecondarySidebar
};
